import { Guest } from '@/entities/conference-participant'

import { Contact } from '@/shared/types/api'
import { fromPServedUser } from '@/shared/utils/uri'

export const guestToContact = (guest: Guest): Contact => ({
  id: guest.pServed,
  name: guest.name,
  internalNumber: fromPServedUser(guest.pServed),
  imLogin: '',
  groupIds: [],
  organization: '',
  position: '',
  terminalLogin: '',
  terminalPassword: '',
  type: 'guest',
})
